import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessagesService } from './logic/message.service';
import { MessagesLogicService } from './logic/message/message-logic.service';
import { MessagesDaoService } from './dao/message-dao.service';
import { MessagesDbDaoService } from './dao/message-dao/message-db-dao.service';
import { MessageDbTableDefinition } from './dao/message-dao/message-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: MessagesService, useClass: MessagesLogicService },
    { provide: MessagesDaoService, useClass: MessagesDbDaoService },
    { provide: MessageDbTableDefinition },
  ]
})
export class MessagesModule {}
